import React from "react";
import styles from "./style.module.css";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

export default class Waterfall extends React.PureComponent {
  attemptSelect(field, values) {
    const dashboard = window.tableau.extensions.dashboardContent.dashboard;

    for (const worksheet of dashboard.worksheets) {
      worksheet
        .selectMarksByValueAsync([{ fieldName: field, value: values }], "select-replace")
        .then((d) => console.log(d));
    }
  }

  handleTableau(bar) {
    if (window.tableau) {
      window.tableau.extensions.initializeDialogAsync().then(() => {
        const field = bar.label;
        const values = Object.keys(bar.values);

        this.attemptSelect(field, values);
      });
    }
  }

  renderBar(bar, index) {
    return (
      <OverlayTrigger
        key={index}
        placement="top"
        trigger={["hover", "focus"]}
        overlay={
          <Popover id="popover-positioned-top" title={bar.label}>
            <div>
              <div className={styles.tooltipHolder}>
                <span className={styles.leftBar} />
                <span className={styles.tooltipInfo}>{bar.leftModel + ": "}</span>
                <span className={styles.tooltipNumber}>{bar.left.toFixed(7)}</span>
              </div>
              <div className={styles.tooltipHolder}>
                <span className={styles.rightBar} />
                <span className={styles.tooltipInfo}>{bar.rightModel + ": "}</span>
                <span className={styles.tooltipNumber}>{bar.right.toFixed(7)}</span>
              </div>
            </div>
          </Popover>
        }
      >
        <div className={styles.bHolder} onClick={() => this.handleTableau(bar)}>
          <div
            className={styles.bar}
            style={{
              width: bar.width,
              marginLeft: bar.marginLeft,
              background: bar.color
            }}
          />
          <div
            className={styles.bar}
            style={{
              width: bar.widthR,
              marginLeft: bar.marginLeftR,
              background: bar.colorR,
              height: "10px"
            }}
          />
          <div className={styles.bLabel}>{bar.label}</div>
        </div>
      </OverlayTrigger>
    );
  }

  render() {
    const { bars, totalLabel, showTotalVal, isStacked } = this.props;

    const colors = ["#92cf48", "#eb332b", "#b1d36f", "#d7a4aa", "var(--aible-color)"];

    let min = -200;
    let max = 200;
    let current = 0;

    let totalDelta = max - min;

    let rBars = [];
    let rCurrent = 0;
    let tCurrent = 0;
    let index = 0;

    for (const bar of bars) {
      const start = Math.min(rCurrent, rCurrent + bar.left);
      const end = Math.max(rCurrent, rCurrent + bar.left);

      const startR = Math.min(rCurrent, rCurrent + bar.right);
      const endR = Math.max(rCurrent, rCurrent + bar.right);

      rBars[index] = {
        ...bar,
        value: bar.left,
        marginLeft: bar.left < 0 ? "calc(" + (50 - ((end - start) / totalDelta) * 100) + "%" + " + 1px)" : "50%",
        marginLeftR: bar.right < 0 ? "calc(" + (50 - ((endR - startR) / totalDelta) * 100) + "%" + " + 1px)" : "50%",
        width: ((end - start) / totalDelta) * 100 + "%",
        widthR: ((endR - startR) / totalDelta) * 100 + "%",
        tooltip: [{ value: bar.left, count: bar.count }],
        color: "#71a1e1",
        colorR: "var(--aible-color)"
      };

      if (bar.isHidden !== true) {
        tCurrent += bar.left;
      }

      rCurrent += bar.left;

      rBars[index].width;
      index++;
    }

    return (
      <div className={styles.hotdog}>
        <div className={styles.legend}>
          <div className={styles.model}>
            <div className={styles.leftBar} />
            <div className={styles.modelId}>{bars && bars[0] && bars[0].leftModel}</div>
          </div>
          <div className={styles.model}>
            <div className={styles.rightBar} />
            <div className={styles.modelId}>{bars && bars[0] && bars[0].rightModel}</div>
          </div>
        </div>
        <div className={styles.scrollWrap}>
          <Scrollbars>
            <div className={styles.valueMatrixHolder} style={{ background: "transparent", width: "100%" }}>
              {rBars.map((bar, index) => this.renderBar(bar, index))}
            </div>
          </Scrollbars>
        </div>
        <div
          className={styles.zero}
          style={{
            marginLeft: "calc(50% - 1px)"
          }}
        />
      </div>
    );
  }
}
